import React, {useState} from 'react';
import HeaderFooterHOC from '../HOC/HeaderFooterHOC';
import FsLightbox from "fslightbox-react";

const FloorPlans = (props) => {

    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1
    });

    function openLightboxOnSlide(number, url) {

        if ( window.innerWidth < 650 ) {
            window.open(url, "_blank");
            return;
        }

        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: number,
        });
    }

    let floorPlansContainOneImage = ( props.floor_plans.length === 1 && props.floor_plans[0]?.mime_type?.includes('image') );

    return (
        <>
            <style>
                {`
                .main-column-right {
                    z-index: unset !important;
                }

                .card {
                    background-color: transparent;
                }

                .card-img-top {
                    width: 100%;
                    ` + ( floorPlansContainOneImage ?
                        'height: 100%;'
                    :
                        'height: 300px;'
                    ) + `
                    object-fit: contain;
                }
                `}
            </style>
            <div className="row">
                {props.floor_plans.map((floor_plan, index) => {
                return (
                    <div className={floorPlansContainOneImage ? "col-sm-12" : "col-sm-6"}>
                        <div className="card mb-4 cursor-pointer" onClick={()=> {
                            openLightboxOnSlide(index+1, floor_plan.url)
                        }}>
                            {floor_plan.mime_type.includes('image') ?
                                <img src={floor_plan.thumb} className="card-img-top" alt={floor_plan.name} />
                                :
                                <img src="/images/filetypes/pdf.png" className="card-img-top p-3" alt={floor_plan.name} />
                            }
                            <div className="card-footer text-center">
                                {floor_plan.name}
                            </div>
                        </div>
                    </div>
                )
                })}
            </div>

            <FsLightbox
                toggler={lightboxController.toggler}
                sources={[...props.floor_plans].map((floor_plan, index) => {
                    if (floor_plan.mime_type === 'application/pdf') {
                        return <embed key={index} src={floor_plan.url} width="2560px"
                                      height="1440px"/>
                    }
                    return floor_plan.url
                })}
                slide={lightboxController.slide}
                key={props.floor_plans.length}
                onClose={props.onClose}
                allowFullScreen={false}
            />
    </>)
}

export default HeaderFooterHOC(FloorPlans, 'floor_plans');
